import React from 'react';
import { CGNav } from './CGNav';
import { useGetUserAuthenticated } from 'common/react/hooks/use-get-user-authenticated';

export const CGFiltersAuthWrapper = (data) => {
    const { userAuthenticated } = useGetUserAuthenticated();

    return userAuthenticated !== null ? (
        <CGNav {...data} userAuthenticated={userAuthenticated} />
    ) : null;
};
